import {useEffect} from 'react';
import {matchPath, useLocation} from 'react-router-dom';
import {routesConfig} from './routesConfig';

const SITE_NAME = 'Espace clients | CELESTE';

type RouteEntry = {pattern: string; title: string};

function flattenRoutes(routes: any[], parentPath = ''): RouteEntry[] {
  const entries: RouteEntry[] = [];

  for (const route of routes) {
    if (route.index) continue;

    const seg = route.path ?? '';
    const currentPath = '/' + [parentPath, seg].filter(Boolean).join('/');

    const breadcrumb = route.meta?.breadcrumb;
    const lastCrumb = Array.isArray(breadcrumb) ? breadcrumb[breadcrumb.length - 1] : null;

    if (lastCrumb?.name) {
      entries.push({pattern: currentPath, title: lastCrumb.name});
    }

    if (route.children) {
      entries.push(...flattenRoutes(route.children, [parentPath, seg].filter(Boolean).join('/')));
    }
  }

  return entries;
}

const PAGE_TITLES = flattenRoutes(routesConfig);

const usePageTitle = () => {
  const {pathname} = useLocation();

  useEffect(() => {
    const matched = PAGE_TITLES.find(({pattern}) =>
      matchPath({path: pattern, end: true}, pathname)
    );
    document.title = matched ? `${matched.title} | ${SITE_NAME}` : SITE_NAME;
  }, [pathname]);
};

export default usePageTitle;
